import styled from "styled-components";

export const PopoverWrapper = styled.div`
  width: 270px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  color: #424242;
  gap: 15px;
`;

export const PropLabel = styled.span`
  font-size: 12px;
`;

export const PropItem = styled.div`
  display: flex;

  ${(props) => props.column && "flex-direction: column;"}

  ${(props) => !props.column && `
    justify-content: space-between;
    align-items: center;

    ${PropLabel} {
      width: 50%;
      text-align: right;
    }
  `}
`;

export const PropHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`;

export const RadiusChangeButton = styled.button`
  cursor: pointer;
  border: none;
  background: transparent;
  display: flex;
  margin-left: 8px;
`;

export const IconWrapper = styled.button`
  background: #fff;
  border: 1px solid #ebebeb;
  border-right: none;
  width: 35px;
  height: 25px;
  cursor: pointer;
`;

export const BoxButtons = styled.div`
  display: flex;
  align-items: center;

    button:first-child {
      border-radius: 3px 0 0 3px;
    }

    button:last-child {
      border-radius: 0 3px 3px 0;
      border-right: 1px solid #ebebeb;
    }

    .active {
      border: 1px solid #44ADF8 !important;
    }
`;

export const InputItem = styled.input`
  border: 1px solid transparent;
  border-radius: 3px;
  background-color: transparent;
  width: 28px;
  text-align: center;
  margin: 0 3px 0;
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &:hover {
    outline: none;
    border: 1px solid #ebebeb;
    background-color: #ffffff;
  }
  &:focus {
    box-shadow: rgb(80 175 244) 0px 0px 2px 1px;
    outline: none;
    border: 1px solid #ebebeb;
    background-color: #ffffff;
  }

  ${(props) => props.inputError && "border-color: #E83535;"}
`;

export const RefContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;
